import { useEffect, useRef, useState } from 'react';
import { getDomainName } from '../../../utils/general';

const UpdateModal = () => {
      const [waitingServiceWorker, setWaitingServiceWorker] = useState(null);
      const [showReload, setShowReload] = useState(false);
      const [initialCheckDone, setInitialCheckDone] = useState(false);
      const modalRef = useRef(null);
    
      useEffect(() => {
        let isMounted = true;
    
        const checkExistingServiceWorker = async () => {
          if ('serviceWorker' in navigator) {
            try {
              const registration = await navigator.serviceWorker.getRegistration();
              if (registration && registration.waiting && isMounted) {
                console.log('Found waiting service worker on mount');
                setWaitingServiceWorker(registration.waiting);
                setShowReload(true);
              }
            } catch (error) {
              console.error('Error checking service worker:', error);
            }
          }
          if (isMounted) setInitialCheckDone(true);
        };
    
        const handleSWUpdate = (event) => {
          console.log('swUpdated event received', event.detail);
          if (isMounted) {
            const registration = event.detail;
            setWaitingServiceWorker(registration.waiting);
            setShowReload(true);
          }
        };
    
        checkExistingServiceWorker();
        window.addEventListener('swUpdated', handleSWUpdate);
    
        return () => {
          isMounted = false;
          window.removeEventListener('swUpdated', handleSWUpdate);
        };
      }, []);
    
      const reloadPage = () => {
        if (waitingServiceWorker) {
          waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
        }
        setTimeout(() => {
          window.location.reload();
        }, 100);
      };
        if (!initialCheckDone) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center space-y-2">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <div className="text-gray-600 text-sm">Loading...</div>
        </div>
      </div>
    );
  }

    return (
        showReload && (
        <div className="fixed inset-0 bg-opacity-30 flex items-end justify-start z-[99]">
          <div
            ref={modalRef}
            className="bg-[#3f434a] rounded-lg shadow-2xl max-w-xs w-full mx-4 mb-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4">
              <div className="flex items-start gap-3 mb-4">
                <button
                  onClick={() => setShowReload(false)}
                  className="absolute top-2 right-2 text-white text-xl leading-none hover:text-gray-300"
                  aria-label="Close"
                >
                  &times;
                </button>
                <div>
                  <h2 className="text-white text-sm font-medium mb-1">
                    {getDomainName()} is ready to update!
                  </h2>
                </div>
              </div>
              <button
                onClick={reloadPage}
                className="w-full bg-white hover:bg-gray-600 text-black text-sm font-medium py-2.5 px-4 rounded-md transition-colors"
              >
                Refresh
              </button>
            </div>
          </div>
        </div>
      )
    )
}
export default UpdateModal;